import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";

const FiveOr7_2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <FiveOr7Div>
      <EventFinished scheduleKeyName="fiveOr7_2025" eventType="promotion" />
      <Hero
        bgImage={`promotions/dining/5-ou-7-2025/5ou7-Header-2560x800px.jpg`}
        buttonSettings={null}
        image={`promotions/dining/5-ou-7-2025/5ou7-Logo-2400px.png`}
        description={t("diningPromos.fiveOr7_2025.hero.title")}
        descriptionBgColor="#0000004d"
      />
      <MainContentDiv>
        <container-div>
          <Row className="g-4 mb-5" xs={1} md={2}>
            <Col>
              <SubTitleSection
                as={"h2"}
                subTitle={t("diningPromos.fiveOr7_2025.content.subtitle")}
              />
              <ReactMarkdown className="desc">
                {t("diningPromos.fiveOr7_2025.content.lunch.description")}
              </ReactMarkdown>
            </Col>
            <Col className="pt-md-4 position-relative">
              <ResponsiveImage
                src={`promotions/dining/5-ou-7-2025/5or7-Secondary-LP-Image-2400x1600.jpg`}
                alt={t("diningPromos.fiveOr7_2025.hero.title")}
              />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
      <container-div>
        <center-content>
          <p className="small">
            {t("diningPromos.fiveOr7_2025.content.smallText")}
          </p>
        </center-content>
      </container-div>
    </FiveOr7Div>
  );
};

const FiveOr7Div = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 0;
    margin: 1rem 0;
    @media (min-width: 768px) {
      margin: 2rem 0;
    }
    opacity: 0.9;
  }
`;

const MainContentDiv = styled.div`
  .desc li strong:nth-child(1) {
    color: #ba121d;
  }
`;

export default FiveOr7_2025;
